import { Control } from 'react-hook-form'
import { BusinessExplainationPayload } from '@/modules/Business/types/payload'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'vnetwork-ui'

interface FollowupExplainationProps {
    control: Control<BusinessExplainationPayload>
    disable?: boolean
}

const FollowupExplaination: React.FC<FollowupExplainationProps> = ({
    control,
    disable,
}) => {
    const { t } = useTranslation()
    return (
        <>
            <div className="space-y-2 mt-2">
                <FormItem
                    control={control}
                    name="provider_explaination"
                    type="textfield"
                    label={t('business-provider-label')}
                    placeholder={t('business-provider-placeholder')}
                    disabled={disable}
                />
            </div>
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 mt-2">
                <div className="col-span-1 space-y-2 mt-2">
                    <FormItem
                        control={control}
                        name="budget_explaination"
                        type="number"
                        label={t('business-budget-label')}
                        placeholder={t('business-budget-placeholder')}
                        disabled={disable}
                    />
                </div>
                <div className="col-span-1 space-y-2 mt-2">
                    <FormItem
                        control={control}
                        name="expected_date"
                        type="datepicker"
                        label={t('business-expected-date-label')}
                        placeholder={t('business-expected-date-placeholder')}
                        disabled={disable}
                    />
                </div>
            </div>
            <div className="space-y-2 mt-4">
                <FormItem
                    control={control}
                    name="influencer_explaination"
                    type="textfield"
                    label={t('business-influencer-label')}
                    placeholder={t('business-influencer-placeholder')}
                    disabled={disable}
                />
            </div>
            <div className="space-y-2 mt-4">
                <FormItem
                    control={control}
                    name="problem_explaination"
                    type="textarea"
                    label={t('business-problem-label')}
                    placeholder={t('business-problem-placeholder')}
                    disabled={disable}
                />
            </div>
            <div className="space-y-2 mt-2">
                <FormItem
                    control={control}
                    name="success_explanation"
                    type="textfield"
                    label={t('business-success-label')}
                    placeholder={t('business-success-placeholder')}
                    disabled={disable}
                />
            </div>
            <div className="space-y-2 mt-4">
                <FormItem
                    control={control}
                    name="success_improvement"
                    type="textarea"
                    label={t('business-result-improvement')}
                    placeholder="N/A"
                    disabled={disable}
                />
            </div>
        </>
    )
}

export default FollowupExplaination
